<template>
    <div id="epg" v-show="epgChannel">
        <div v-if="epgLoading">
            <h4 class="programs_empty-text">Загрузка...</h4>
        </div>
        <div v-else>
            <div class="epg-fixed">
                <div class="epg_controls">
                    <div class="epg_controls_button prev-button" @click="epgPrevDay"><i class="icon-arrow-left"></i></div>
                    <div class="epg_controls_button next-button" @click="epgNextDay"><i class="icon-arrow-right"></i></div>
                </div>
                <h3 class="day-title">{{(epgChannel) ? epgChannel.name : ''}} <br> {{formattedDate}}</h3>
            </div>

            <div class="epg_programs">
                <h4 v-show="epgList.length === 0" class="programs_empty-text">Программа передач отсутствует</h4>
                <table v-show="epgList.length !== 0">
                    <tr>
                        <th>Архив</th>
                        <th>Время</th>
                        <th>Название</th>
                    </tr>
                    <tr v-for="(program, index) in epgList" :key="index" class="program-item">
                        <td style="color: #999;">
                            <div v-if="program.ut_start <= nowUTC">
                                <div v-if="archiveProgramInfo.utStart == program.ut_start && archiveProgramInfo.channelId == epgChannel.id">
                                    <div :title="$parent.$parent.mode === 'teleteka' ? 'Играет сейчас (телетека)' : 'Играет сейчас (архив)'" style="font-size: 20px;">
                                        <i class="icon-control-play-filled"></i>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="program.ut_end < nowUTC && program.ut_start < nowUTC">
                                        <div v-if="$parent.teletekaEnabled && program.teleteka" title="Есть телетека" style="font-size: 20px;color:#2196F3;">
                                            T
                                        </div>
                                        <div title="Есть архив" style="font-size: 20px;color:red;" v-else>
                                            R
                                        </div>
                                    </div>
                                    <div title="Играет сейчас (live)" style="font-size: 20px;color:greenyellow;" v-else>
                                        L
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td style="color: #999;">{{program.ut_start | time}}</td>
                        <td>
                            <a v-if="program.ut_end < nowUTC && program.ut_start < nowUTC" href="#" @click.prevent="openProgram(program, index)">{{program.progname}}</a>
                            <span v-else>{{program.progname}}</span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                epgLoading: false
            }
        },
        computed: {
            ...mapState({
                nowUTC: state => state.epg.nowUTC,
                epgList: state => state.epg.epgList,
                epgChannel: state => state.epg.epgChannel
            })
        },
        watch: {
            epgList(newValue, oldValue) {
                if (oldValue !== newValue) {
                    this.epgList
                        .forEach((program, index) => {
                            this.$parent.countProgramEnd(index)
                                .then(utEnd => {
                                    this.setProgramEnd({index, utEnd});
                                })
                        });
                }
                this.epgLoading = false;
            }
        },
        filters: {
            time(v) {
                let time = new Date(v * 1000);
                return time.getHours() + ':' + ((time.getMinutes() < 10) ? '0' + time.getMinutes() : time.getMinutes());
            }
        },
        props: ['formattedDate', 'archiveProgramInfo'],
        methods: {
            ...mapActions([
                'setProgramEnd'
            ]),
            epgPrevDay() {
                this.epgLoading = true;
                this.$emit('epgPrevDay');
            },
            epgNextDay() {
                this.epgLoading = true;
                this.$emit('epgNextDay');
            },
            openProgram(program, index) {
                this.$emit('openProgram', program, index);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Epg.vue?d0ccb3f0